<template>
  <div
    class="account__plan-list-item"
    :class="{ 'account__plan-list-item--dark': index % 2 === 0 }"
  >
    <dt class="account__plan-list-item-name">
      <strong>{{ name | capitalizeFirstLetter }}:</strong>
    </dt>
    <dd class="weight--light">{{ value | capitalizeFirstLetter }}</dd>
  </div>
</template>

<script>
export default {
  name: "PlanListItem",
  props: {
    name: String,
    value: String,
    index: Number,
  },
};
</script>

<style></style>
